var _extends = {exports: {}};

export { _extends as __module };
